import Suppliers from './Suppliers'
export default Suppliers
